<template>
  <div class="m-content">
    <template>
      <HeaderBox />
      <div class="report-content">
        <p class="tip"><span @click="handleBack">查看走过的足迹</span></p>
        <div class="report-area">
          <p class="report-title">{{nickName}}的性格类型为</p>
          <p class="big-title">{{mbtiFeature.type}}&nbsp;{{mbtiFeature.role}}</p>
          <img class="report-img" :src="imgUrl" />
        </div>
        <div class="report-area">
          <p class="report-title">行为风格</p>
          <p v-html="replaceText(mbtiFeature.behaviorStyle)"></p>
        </div>
        <div class="report-area">
          <p class="report-title">主要特征</p>
          <p v-html="replaceText(mbtiFeature.mainFeature)"></p>
        </div>
        <div class="report-area">
          <p class="report-title">给TA人的印象</p>
          <p v-html="replaceText(mbtiFeature.impression)"></p>
        </div>
        <div class="report-area">
          <p class="report-title">发展中需要注意的方面</p>
          <p v-html="replaceText(mbtiFeature.attention)"></p>
        </div>
        <div class="report-area">
          <p class="report-title">与行为风格相适合的职场</p>
          <p v-html="replaceText(mbtiFeature.job)"></p>
        </div>
      </div>
      <FootBox :id="id"/>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios';
  import qs from 'qs';
  import store from '../store/index'
  import HeaderBox from '@/components/mission/headerBox.vue'
  import FootBox from '@/components/mission/footBox.vue'
  import setWechatTitle from '@/utils/setWechatTitle.js'

  export default {
    props: {
      id: Number
    },
    name: 'ZooResult',
    components: {
      HeaderBox,
      FootBox
    },
    data() {
      return {
        mbtiFeature: {},  /* 文字内容 */
        imgUrl: '',  /* 图片地址 */
        nickName: ''  /* 昵称 */
      };
    },
    computed: {
      ...mapState({
        shengyaUser: state => state.shengyaUser.userInfo,
      }),
    },

    created: function() {
      setWechatTitle('生涯驿站-疯狂动物城')
      this.getReport()
    },
    methods: {
      // 对文本进行处理,换行
      replaceText(txt){
        if(txt){
          const new_txt = txt.replace(/\n/g,'</br>');
          return new_txt;
        }
      },
      // 获取报告结果
      getReport(result) {
        this.results = [];
        const options = {
          method: 'post',
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          },
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url: '/cob/cosAnimalReport.do'
        };
        axios(options)
          .then((response)=>{
            if(response.data.result.success){
              let mbtiResult = response.data.data;
              this.nickName = mbtiResult.nickname;
              this.imgUrl = mbtiResult.cosAnimal.mbtiImage2 + '?' + new Date().getTime();
              if (mbtiResult.cosAnimal.mbtiFeature) {
                this.mbtiFeature = mbtiResult.cosAnimal.mbtiFeature;
                // 弹幕
                let num= parseInt(Math.random()),
                text = '的性格代表动物居然是'+this.mbtiFeature.animal
                if(num){
                  text = '的性格类型是'+this.mbtiFeature.type
                }
                store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
              }
            }
          })
          .catch((error)=>{
            console.log(error);
          })
      },
      handleBack(){
        this.$bus.$emit('result-view',this.mbtiFeature.type)
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .tip
    text-align:center
    font-size:0.24rem
    color:#C31216
</style>
